import type { ClientBankAccount } from '../../services/bankAccounts.service';
import type { AwaitingPayout } from '../../services/clientPayouts.service';

/** Payouts that still need the client: the ones with no destination chosen. */
export function needingDestination(payouts: AwaitingPayout[]): AwaitingPayout[] {
  return payouts.filter((p) => p.current_destination_id === null);
}

/** The accounts a payout may be sent to: the client's active ones in its currency. */
export function eligibleAccounts(
  payout: AwaitingPayout, accounts: ClientBankAccount[],
): ClientBankAccount[] {
  return accounts.filter((a) => a.is_active && a.currency_code === payout.currency_code);
}
